<template>
  <v-speed-dial
    v-model="fab"
    direction="right"
    fixed
    left
    bottom
    transition="slide-x-transition"
    style="z-index:9;"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="blue darken-2" dark fab>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-cog-outline</v-icon>
      </v-btn>
    </template>
    <v-btn fab dark small color="success" title="Esporta le impostazioni attuali" @click="esportaImpostazioni">
      <!-- <v-icon>mdi-cog-transfer-outline</v-icon> -->
      <v-icon>mdi-folder-cog-outline</v-icon>
    </v-btn> 
    <v-btn fab dark small color="indigo" title="Carica impostazioni personalizzate" @click="caricaImpostazioni">
      <v-icon>mdi-cog-sync-outline</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  data() {
    return {
      fab: false
    }
  },
  methods: {
    caricaImpostazioni() {
      this.$emit('comando', 'carica-impostazioni')
    },
    esportaImpostazioni() {
      this.$emit('comando', 'esporta-impostazioni')
    }
  }  
}
</script>